<template lang="pug">
  .ads-carousel
    .ads-loading-mask(v-if="loading")
    swiper(
      :options="adsSwiper",
      v-if="events.length>0")
      swiper-slide(v-for="(event,eid) in events", :key="'ads-'+eid")
        img(
          src="@/assets/img/preload_eventbanner.svg",
          v-if="events.length<1"
          )
        img(:src="event.pic",v-else)
        a.no-blue-highlight(:href="event.link",:alt="event.title")
      .ads-pagination(slot="pagination")
</template>

<script>
export default {
  name: 'ads-carousel',
  components:{
  },
  props:{
    events: {
      type:Array,
      required: true,
      default: function(){
        return [];
      }
    },
    loading:{
      type: Boolean,
      required: false,
      default: true
    }
  },
  data(){
    return{
      adsSwiper:{
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 8,
        autoplay:{
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
        pagination:{
          el: '.ads-pagination'
        }
      },
    }
  },
  methods: {
    
  },
  watch:{
    // events(){
    //   // console.log('updated ads')
    //   this.adsSwiper = {
    //     slidesPerView: 1,
    //     spaceBetween: 8,
    //     autoplay:{
    //       delay: 5000,
    //       disableOnInteraction: true
    //     },
    //     loop: true
    //   }
    // }
  }
}
</script>

<style lang="scss">
</style>
